import React, { useRef } from 'react';
import { useFormContext } from '../../components/FormContext';


const WWCCSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFieldValue,
    setFormErrors, 
    setFile,
    setModifiedFields
  } = useFormContext();
const wwccInputRef = useRef(null);

const validatePDFFile = (field, e) => {
    
    const file = e.target.files[0];
    setFile('wwcc', file);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!file) {
      
      error = `PDF file is required for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
      
    } else if (field === 'wwcc' && file.type !== 'application/pdf') {
        
      error = `PDFs are the only excepted file for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
    } 
        
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };

// Handle select input change
  const handleSelectChange = (field, e) => {
    const value = e.target.value;
    
    setFieldValue('hasWWCC', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    
    if (value.trim() === '' ) {
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else if (field === 'hasWWCC' && value === 'No') {
        setFieldValue('wwcc', null);
        setFieldValue('wwccExpiry', '');
        setModifiedFields(prev => new Set([...prev, field]));

      
    }
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
    
  };

 
const validateFutureDate = (field, e) => {
  const value = e.target.value;
    setFieldValue('wwccExpiry', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
  
  
  
  if (!value) {
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else {
        
      const selectedDate = new Date(value);
      const today = new Date();
        
      if (selectedDate < today) {
          error = `${field.charAt(0).toUpperCase() + field.slice(1)} cannot be in the past`; 
        }
        
      
    }
  
  if (error) {
          setFormErrors(prev => ({...prev, [field]: error}));
        } else {
          setFormErrors(prev => {
            const newErrors = {...prev};
            delete newErrors[field];
            return newErrors;
          });
        }
};






  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Working With Children Info</h4>
        <div className="space-y-4">
          <div>
            <label htmlFor="has-wwcc" className="block text-sm font-medium text-gray-700 mb-1">
                Working With Children
            </label>
            <select
              id="has-wwcc"
              name="hasWWCC"
              value={formData.hasWWCC}
              onChange={(e) => handleSelectChange('hasWWCC', e)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
                  
            {formErrors.hasWWCC && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('hasWWCC') && (
            <div className="text-sm text-red-600 mt-1">
                {formErrors.hasWWCC}
            </div>
            )}
          </div>
                
          {formData.hasWWCC === 'Yes' && (
              <>
              <div>
              <input
                id="wwcc-upload"
                type="file"
                name="wwcc"
                accept=".pdf"
                className="hidden"
                onChange={(e) => validatePDFFile('wwcc',e)}
                ref={wwccInputRef}
              />
                  
                {!formData.wwcc ? (
                  <button
                    type="button"
                    onClick={() => wwccInputRef.current.click()}
                    className="upload-button flex items-center justify-center px-4 py-2 w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg shadow hover:from-blue-600 hover:to-indigo-700 transition-all duration-200"
                    >
                    <span className="font-medium">Upload Working With Children Check</span>
                  </button>
                      ) : (
                    <div className="file-info p-3 bg-gray-50 rounded-md border border-gray-200">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <span className="file-name text-sm font-medium text-gray-700">
                          {formData.wwcc.name}
                        </span>
                        </div>
                          <button
                          type="button"
                          onClick={() => {
                          setFile('wwcc', null);
                        
                          validatePDFFile('wwcc', { target: { files: [] } });
                          }}
                          className="text-sm text-red-600 hover:text-red-800 font-medium"
                          >
                          Remove
                        </button>
                            
                    </div>
                </div>
              )}
                      
                {formErrors.wwcc && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('wwcc') && (
                  <div className="text-sm text-red-600 mt-1">
                    {formErrors.wwcc}
                </div>
              )}
          </div>
        <div>
            <label htmlFor="wwcc-expiry" className="block text-sm font-medium text-gray-700 mb-1">
                Working With Children Check Expiry Date
            </label>
            <input
              type="date"
              id="wwcc-expiry"
              name="wwccExpiry"
              value={formData.wwccExpiry}
              onChange={(e) => validateFutureDate('wwccExpiry', e)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
                      
              {formErrors.wwccExpiry && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('wwccExpiry') && (
              <div className="text-sm text-red-600 mt-1">
                {formErrors.wwccExpiry}
              </div>
              )}
              </div>
            </>
          )}
      </div>
    </div>
 
  );

};

export default WWCCSection;